//hooks
import { useState } from "react";
import  { NotificationConsumer } from "./context/NotificationContext";

//tranlsate
import { useTranslation } from 'react-i18next';
import { GetLogoutApi } from "../api/GetLogoutApi";

export const useApi = <TArgs extends any[]>(apiFunc: (...args: TArgs) => Promise<any>,method: string) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const { setNoteMessage, setShowMessage, setStatusCode } = NotificationConsumer();

  const HandlerApi = async (...args: TArgs): Promise<any> => {
    setLoading(true);
    setError(false);
    // Offline check
    if (!navigator.onLine) {
      setError(true);
      setNoteMessage(t("no_internet_connection"));
      setStatusCode(0);
      setShowMessage(true);
      setLoading(false);
      return {data: null}
    }
    try {
      const result = await apiFunc(...args);
      if (method !== "GET" || apiFunc === GetLogoutApi) {
        setNoteMessage(result?.message);
        setShowMessage(true);
        setStatusCode(result?.code);
      }
      return result;
    }
    catch (err: any) {
      console.log("error useapi",err);
      setError(true);
      if (method !== "GET") {
        setNoteMessage(err?.response?.data?.message);
        setStatusCode(err?.response?.status || 500);
        setShowMessage(true);
      }
      return {data: null}
    }
    finally {
      setLoading(false);
    }
  };

  return { loading, error, HandlerApi };
};
